var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJoinTribeQr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 500,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-dot-color"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 164,
    width: 19,
    height: 19,
    transform: "rotate(0,21.5,173.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 202,
    width: 19,
    height: 19,
    transform: "rotate(0,21.5,211.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 259,
    width: 19,
    height: 19,
    transform: "rotate(0,21.5,268.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 278,
    width: 19,
    height: 19,
    transform: "rotate(0,21.5,287.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 297,
    width: 19,
    height: 19,
    transform: "rotate(0,21.5,306.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 316,
    width: 19,
    height: 19,
    transform: "rotate(0,21.5,325.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 240,
    width: 19,
    height: 19,
    transform: "rotate(0,40.5,249.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 259,
    width: 19,
    height: 19,
    transform: "rotate(0,40.5,268.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 278,
    width: 19,
    height: 19,
    transform: "rotate(0,40.5,287.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 297,
    width: 19,
    height: 19,
    transform: "rotate(0,40.5,306.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 164,
    width: 19,
    height: 19,
    transform: "rotate(0,59.5,173.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 183,
    width: 19,
    height: 19,
    transform: "rotate(0,59.5,192.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 202,
    width: 19,
    height: 19,
    transform: "rotate(0,59.5,211.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 164,
    width: 19,
    height: 19,
    transform: "rotate(0,78.5,173.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 183,
    width: 19,
    height: 19,
    transform: "rotate(0,78.5,192.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 202,
    width: 19,
    height: 19,
    transform: "rotate(0,78.5,211.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 221,
    width: 19,
    height: 19,
    transform: "rotate(0,78.5,230.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 240,
    width: 19,
    height: 19,
    transform: "rotate(0,78.5,249.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 259,
    width: 19,
    height: 19,
    transform: "rotate(0,78.5,268.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 278,
    width: 19,
    height: 19,
    transform: "rotate(0,78.5,287.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 297,
    width: 19,
    height: 19,
    transform: "rotate(0,78.5,306.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 202,
    width: 19,
    height: 19,
    transform: "rotate(0,97.5,211.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 240,
    width: 19,
    height: 19,
    transform: "rotate(0,97.5,249.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 278,
    width: 19,
    height: 19,
    transform: "rotate(0,97.5,287.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 316,
    width: 19,
    height: 19,
    transform: "rotate(0,97.5,325.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107,
    y: 164,
    width: 19,
    height: 19,
    transform: "rotate(0,116.5,173.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107,
    y: 202,
    width: 19,
    height: 19,
    transform: "rotate(0,116.5,211.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107,
    y: 259,
    width: 19,
    height: 19,
    transform: "rotate(0,116.5,268.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107,
    y: 278,
    width: 19,
    height: 19,
    transform: "rotate(0,116.5,287.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107,
    y: 297,
    width: 19,
    height: 19,
    transform: "rotate(0,116.5,306.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 164,
    width: 19,
    height: 19,
    transform: "rotate(0,135.5,173.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 202,
    width: 19,
    height: 19,
    transform: "rotate(0,135.5,211.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 240,
    width: 19,
    height: 19,
    transform: "rotate(0,135.5,249.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 278,
    width: 19,
    height: 19,
    transform: "rotate(0,135.5,287.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 316,
    width: 19,
    height: 19,
    transform: "rotate(0,135.5,325.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 164,
    width: 19,
    height: 19,
    transform: "rotate(0,154.5,173.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 202,
    width: 19,
    height: 19,
    transform: "rotate(0,154.5,211.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 278,
    width: 19,
    height: 19,
    transform: "rotate(0,154.5,287.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 316,
    width: 19,
    height: 19,
    transform: "rotate(0,154.5,325.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 31,
    width: 19,
    height: 19,
    transform: "rotate(0,173.5,40.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 69,
    width: 19,
    height: 19,
    transform: "rotate(0,173.5,78.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 107,
    width: 19,
    height: 19,
    transform: "rotate(0,173.5,116.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 126,
    width: 19,
    height: 19,
    transform: "rotate(0,173.5,135.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 145,
    width: 19,
    height: 19,
    transform: "rotate(0,173.5,154.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 164,
    width: 19,
    height: 19,
    transform: "rotate(0,173.5,173.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 183,
    width: 19,
    height: 19,
    transform: "rotate(0,173.5,192.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 202,
    width: 19,
    height: 19,
    transform: "rotate(0,173.5,211.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 221,
    width: 19,
    height: 19,
    transform: "rotate(0,173.5,230.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 240,
    width: 19,
    height: 19,
    transform: "rotate(0,173.5,249.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 278,
    width: 19,
    height: 19,
    transform: "rotate(0,173.5,287.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 316,
    width: 19,
    height: 19,
    transform: "rotate(0,173.5,325.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 335,
    width: 19,
    height: 19,
    transform: "rotate(0,173.5,344.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 354,
    width: 19,
    height: 19,
    transform: "rotate(0,173.5,363.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 373,
    width: 19,
    height: 19,
    transform: "rotate(0,173.5,382.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 411,
    width: 19,
    height: 19,
    transform: "rotate(0,173.5,420.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 430,
    width: 19,
    height: 19,
    transform: "rotate(0,173.5,439.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 468,
    width: 19,
    height: 19,
    transform: "rotate(0,173.5,477.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183,
    y: 12,
    width: 19,
    height: 19,
    transform: "rotate(0,192.5,21.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183,
    y: 50,
    width: 19,
    height: 19,
    transform: "rotate(0,192.5,59.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183,
    y: 69,
    width: 19,
    height: 19,
    transform: "rotate(0,192.5,78.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183,
    y: 88,
    width: 19,
    height: 19,
    transform: "rotate(0,192.5,97.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183,
    y: 107,
    width: 19,
    height: 19,
    transform: "rotate(0,192.5,116.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183,
    y: 183,
    width: 19,
    height: 19,
    transform: "rotate(0,192.5,192.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183,
    y: 202,
    width: 19,
    height: 19,
    transform: "rotate(0,192.5,211.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183,
    y: 240,
    width: 19,
    height: 19,
    transform: "rotate(0,192.5,249.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183,
    y: 297,
    width: 19,
    height: 19,
    transform: "rotate(0,192.5,306.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183,
    y: 316,
    width: 19,
    height: 19,
    transform: "rotate(0,192.5,325.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183,
    y: 335,
    width: 19,
    height: 19,
    transform: "rotate(0,192.5,344.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183,
    y: 468,
    width: 19,
    height: 19,
    transform: "rotate(0,192.5,477.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 31,
    width: 19,
    height: 19,
    transform: "rotate(0,211.5,40.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 50,
    width: 19,
    height: 19,
    transform: "rotate(0,211.5,59.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 69,
    width: 19,
    height: 19,
    transform: "rotate(0,211.5,78.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 88,
    width: 19,
    height: 19,
    transform: "rotate(0,211.5,97.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 107,
    width: 19,
    height: 19,
    transform: "rotate(0,211.5,116.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 126,
    width: 19,
    height: 19,
    transform: "rotate(0,211.5,135.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 164,
    width: 19,
    height: 19,
    transform: "rotate(0,211.5,173.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 183,
    width: 19,
    height: 19,
    transform: "rotate(0,211.5,192.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 202,
    width: 19,
    height: 19,
    transform: "rotate(0,211.5,211.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 316,
    width: 19,
    height: 19,
    transform: "rotate(0,211.5,325.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 335,
    width: 19,
    height: 19,
    transform: "rotate(0,211.5,344.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 373,
    width: 19,
    height: 19,
    transform: "rotate(0,211.5,382.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 449,
    width: 19,
    height: 19,
    transform: "rotate(0,211.5,458.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 468,
    width: 19,
    height: 19,
    transform: "rotate(0,211.5,477.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221,
    y: 12,
    width: 19,
    height: 19,
    transform: "rotate(0,230.5,21.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221,
    y: 31,
    width: 19,
    height: 19,
    transform: "rotate(0,230.5,40.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221,
    y: 50,
    width: 19,
    height: 19,
    transform: "rotate(0,230.5,59.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221,
    y: 69,
    width: 19,
    height: 19,
    transform: "rotate(0,230.5,78.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221,
    y: 88,
    width: 19,
    height: 19,
    transform: "rotate(0,230.5,97.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221,
    y: 145,
    width: 19,
    height: 19,
    transform: "rotate(0,230.5,154.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221,
    y: 164,
    width: 19,
    height: 19,
    transform: "rotate(0,230.5,173.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221,
    y: 221,
    width: 19,
    height: 19,
    transform: "rotate(0,230.5,230.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221,
    y: 259,
    width: 19,
    height: 19,
    transform: "rotate(0,230.5,268.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221,
    y: 297,
    width: 19,
    height: 19,
    transform: "rotate(0,230.5,306.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221,
    y: 335,
    width: 19,
    height: 19,
    transform: "rotate(0,230.5,344.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221,
    y: 354,
    width: 19,
    height: 19,
    transform: "rotate(0,230.5,363.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221,
    y: 373,
    width: 19,
    height: 19,
    transform: "rotate(0,230.5,382.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 12,
    width: 19,
    height: 19,
    transform: "rotate(0,249.5,21.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 107,
    width: 19,
    height: 19,
    transform: "rotate(0,249.5,116.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 126,
    width: 19,
    height: 19,
    transform: "rotate(0,249.5,135.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 145,
    width: 19,
    height: 19,
    transform: "rotate(0,249.5,154.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 183,
    width: 19,
    height: 19,
    transform: "rotate(0,249.5,192.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 202,
    width: 19,
    height: 19,
    transform: "rotate(0,249.5,211.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 240,
    width: 19,
    height: 19,
    transform: "rotate(0,249.5,249.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 278,
    width: 19,
    height: 19,
    transform: "rotate(0,249.5,287.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 297,
    width: 19,
    height: 19,
    transform: "rotate(0,249.5,306.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 316,
    width: 19,
    height: 19,
    transform: "rotate(0,249.5,325.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 335,
    width: 19,
    height: 19,
    transform: "rotate(0,249.5,344.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 354,
    width: 19,
    height: 19,
    transform: "rotate(0,249.5,363.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 392,
    width: 19,
    height: 19,
    transform: "rotate(0,249.5,401.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 411,
    width: 19,
    height: 19,
    transform: "rotate(0,249.5,420.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 449,
    width: 19,
    height: 19,
    transform: "rotate(0,249.5,458.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 468,
    width: 19,
    height: 19,
    transform: "rotate(0,249.5,477.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259,
    y: 69,
    width: 19,
    height: 19,
    transform: "rotate(0,268.5,78.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259,
    y: 107,
    width: 19,
    height: 19,
    transform: "rotate(0,268.5,116.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259,
    y: 145,
    width: 19,
    height: 19,
    transform: "rotate(0,268.5,154.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259,
    y: 183,
    width: 19,
    height: 19,
    transform: "rotate(0,268.5,192.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259,
    y: 202,
    width: 19,
    height: 19,
    transform: "rotate(0,268.5,211.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259,
    y: 240,
    width: 19,
    height: 19,
    transform: "rotate(0,268.5,249.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259,
    y: 259,
    width: 19,
    height: 19,
    transform: "rotate(0,268.5,268.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259,
    y: 297,
    width: 19,
    height: 19,
    transform: "rotate(0,268.5,306.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259,
    y: 335,
    width: 19,
    height: 19,
    transform: "rotate(0,268.5,344.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259,
    y: 373,
    width: 19,
    height: 19,
    transform: "rotate(0,268.5,382.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259,
    y: 411,
    width: 19,
    height: 19,
    transform: "rotate(0,268.5,420.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259,
    y: 430,
    width: 19,
    height: 19,
    transform: "rotate(0,268.5,439.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259,
    y: 468,
    width: 19,
    height: 19,
    transform: "rotate(0,268.5,477.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278,
    y: 12,
    width: 19,
    height: 19,
    transform: "rotate(0,287.5,21.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278,
    y: 69,
    width: 19,
    height: 19,
    transform: "rotate(0,287.5,78.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278,
    y: 107,
    width: 19,
    height: 19,
    transform: "rotate(0,287.5,116.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278,
    y: 126,
    width: 19,
    height: 19,
    transform: "rotate(0,287.5,135.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278,
    y: 183,
    width: 19,
    height: 19,
    transform: "rotate(0,287.5,192.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278,
    y: 259,
    width: 19,
    height: 19,
    transform: "rotate(0,287.5,268.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278,
    y: 278,
    width: 19,
    height: 19,
    transform: "rotate(0,287.5,287.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278,
    y: 316,
    width: 19,
    height: 19,
    transform: "rotate(0,287.5,325.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278,
    y: 335,
    width: 19,
    height: 19,
    transform: "rotate(0,287.5,344.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278,
    y: 373,
    width: 19,
    height: 19,
    transform: "rotate(0,287.5,382.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278,
    y: 392,
    width: 19,
    height: 19,
    transform: "rotate(0,287.5,401.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278,
    y: 430,
    width: 19,
    height: 19,
    transform: "rotate(0,287.5,439.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278,
    y: 468,
    width: 19,
    height: 19,
    transform: "rotate(0,287.5,477.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297,
    y: 31,
    width: 19,
    height: 19,
    transform: "rotate(0,306.5,40.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297,
    y: 50,
    width: 19,
    height: 19,
    transform: "rotate(0,306.5,59.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297,
    y: 164,
    width: 19,
    height: 19,
    transform: "rotate(0,306.5,173.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297,
    y: 221,
    width: 19,
    height: 19,
    transform: "rotate(0,306.5,230.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297,
    y: 278,
    width: 19,
    height: 19,
    transform: "rotate(0,306.5,287.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297,
    y: 392,
    width: 19,
    height: 19,
    transform: "rotate(0,306.5,401.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297,
    y: 449,
    width: 19,
    height: 19,
    transform: "rotate(0,306.5,458.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 12,
    width: 19,
    height: 19,
    transform: "rotate(0,325.5,21.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 31,
    width: 19,
    height: 19,
    transform: "rotate(0,325.5,40.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 50,
    width: 19,
    height: 19,
    transform: "rotate(0,325.5,59.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 88,
    width: 19,
    height: 19,
    transform: "rotate(0,325.5,97.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 126,
    width: 19,
    height: 19,
    transform: "rotate(0,325.5,135.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 145,
    width: 19,
    height: 19,
    transform: "rotate(0,325.5,154.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 202,
    width: 19,
    height: 19,
    transform: "rotate(0,325.5,211.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 221,
    width: 19,
    height: 19,
    transform: "rotate(0,325.5,230.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 240,
    width: 19,
    height: 19,
    transform: "rotate(0,325.5,249.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 259,
    width: 19,
    height: 19,
    transform: "rotate(0,325.5,268.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 278,
    width: 19,
    height: 19,
    transform: "rotate(0,325.5,287.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 316,
    width: 19,
    height: 19,
    transform: "rotate(0,325.5,325.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 335,
    width: 19,
    height: 19,
    transform: "rotate(0,325.5,344.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 354,
    width: 19,
    height: 19,
    transform: "rotate(0,325.5,363.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 373,
    width: 19,
    height: 19,
    transform: "rotate(0,325.5,382.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 392,
    width: 19,
    height: 19,
    transform: "rotate(0,325.5,401.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 411,
    width: 19,
    height: 19,
    transform: "rotate(0,325.5,420.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316,
    y: 430,
    width: 19,
    height: 19,
    transform: "rotate(0,325.5,439.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335,
    y: 164,
    width: 19,
    height: 19,
    transform: "rotate(0,344.5,173.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335,
    y: 240,
    width: 19,
    height: 19,
    transform: "rotate(0,344.5,249.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335,
    y: 259,
    width: 19,
    height: 19,
    transform: "rotate(0,344.5,268.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335,
    y: 278,
    width: 19,
    height: 19,
    transform: "rotate(0,344.5,287.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335,
    y: 316,
    width: 19,
    height: 19,
    transform: "rotate(0,344.5,325.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335,
    y: 392,
    width: 19,
    height: 19,
    transform: "rotate(0,344.5,401.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335,
    y: 411,
    width: 19,
    height: 19,
    transform: "rotate(0,344.5,420.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335,
    y: 468,
    width: 19,
    height: 19,
    transform: "rotate(0,344.5,477.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354,
    y: 164,
    width: 19,
    height: 19,
    transform: "rotate(0,363.5,173.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354,
    y: 202,
    width: 19,
    height: 19,
    transform: "rotate(0,363.5,211.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354,
    y: 221,
    width: 19,
    height: 19,
    transform: "rotate(0,363.5,230.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354,
    y: 316,
    width: 19,
    height: 19,
    transform: "rotate(0,363.5,325.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354,
    y: 354,
    width: 19,
    height: 19,
    transform: "rotate(0,363.5,363.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354,
    y: 392,
    width: 19,
    height: 19,
    transform: "rotate(0,363.5,401.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354,
    y: 411,
    width: 19,
    height: 19,
    transform: "rotate(0,363.5,420.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354,
    y: 449,
    width: 19,
    height: 19,
    transform: "rotate(0,363.5,458.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354,
    y: 468,
    width: 19,
    height: 19,
    transform: "rotate(0,363.5,477.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373,
    y: 164,
    width: 19,
    height: 19,
    transform: "rotate(0,382.5,173.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373,
    y: 183,
    width: 19,
    height: 19,
    transform: "rotate(0,382.5,192.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373,
    y: 221,
    width: 19,
    height: 19,
    transform: "rotate(0,382.5,230.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373,
    y: 259,
    width: 19,
    height: 19,
    transform: "rotate(0,382.5,268.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373,
    y: 278,
    width: 19,
    height: 19,
    transform: "rotate(0,382.5,287.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373,
    y: 316,
    width: 19,
    height: 19,
    transform: "rotate(0,382.5,325.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373,
    y: 392,
    width: 19,
    height: 19,
    transform: "rotate(0,382.5,401.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373,
    y: 411,
    width: 19,
    height: 19,
    transform: "rotate(0,382.5,420.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373,
    y: 430,
    width: 19,
    height: 19,
    transform: "rotate(0,382.5,439.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373,
    y: 449,
    width: 19,
    height: 19,
    transform: "rotate(0,382.5,458.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392,
    y: 183,
    width: 19,
    height: 19,
    transform: "rotate(0,401.5,192.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392,
    y: 202,
    width: 19,
    height: 19,
    transform: "rotate(0,401.5,211.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392,
    y: 221,
    width: 19,
    height: 19,
    transform: "rotate(0,401.5,230.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392,
    y: 259,
    width: 19,
    height: 19,
    transform: "rotate(0,401.5,268.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392,
    y: 278,
    width: 19,
    height: 19,
    transform: "rotate(0,401.5,287.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392,
    y: 316,
    width: 19,
    height: 19,
    transform: "rotate(0,401.5,325.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392,
    y: 335,
    width: 19,
    height: 19,
    transform: "rotate(0,401.5,344.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392,
    y: 354,
    width: 19,
    height: 19,
    transform: "rotate(0,401.5,363.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392,
    y: 373,
    width: 19,
    height: 19,
    transform: "rotate(0,401.5,382.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392,
    y: 392,
    width: 19,
    height: 19,
    transform: "rotate(0,401.5,401.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392,
    y: 411,
    width: 19,
    height: 19,
    transform: "rotate(0,401.5,420.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392,
    y: 468,
    width: 19,
    height: 19,
    transform: "rotate(0,401.5,477.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411,
    y: 164,
    width: 19,
    height: 19,
    transform: "rotate(0,420.5,173.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411,
    y: 202,
    width: 19,
    height: 19,
    transform: "rotate(0,420.5,211.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411,
    y: 221,
    width: 19,
    height: 19,
    transform: "rotate(0,420.5,230.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411,
    y: 278,
    width: 19,
    height: 19,
    transform: "rotate(0,420.5,287.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411,
    y: 297,
    width: 19,
    height: 19,
    transform: "rotate(0,420.5,306.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411,
    y: 373,
    width: 19,
    height: 19,
    transform: "rotate(0,420.5,382.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411,
    y: 392,
    width: 19,
    height: 19,
    transform: "rotate(0,420.5,401.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411,
    y: 411,
    width: 19,
    height: 19,
    transform: "rotate(0,420.5,420.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411,
    y: 430,
    width: 19,
    height: 19,
    transform: "rotate(0,420.5,439.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430,
    y: 183,
    width: 19,
    height: 19,
    transform: "rotate(0,439.5,192.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430,
    y: 221,
    width: 19,
    height: 19,
    transform: "rotate(0,439.5,230.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430,
    y: 240,
    width: 19,
    height: 19,
    transform: "rotate(0,439.5,249.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430,
    y: 297,
    width: 19,
    height: 19,
    transform: "rotate(0,439.5,306.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430,
    y: 354,
    width: 19,
    height: 19,
    transform: "rotate(0,439.5,363.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430,
    y: 373,
    width: 19,
    height: 19,
    transform: "rotate(0,439.5,382.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430,
    y: 392,
    width: 19,
    height: 19,
    transform: "rotate(0,439.5,401.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430,
    y: 430,
    width: 19,
    height: 19,
    transform: "rotate(0,439.5,439.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430,
    y: 468,
    width: 19,
    height: 19,
    transform: "rotate(0,439.5,477.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449,
    y: 164,
    width: 19,
    height: 19,
    transform: "rotate(0,458.5,173.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449,
    y: 240,
    width: 19,
    height: 19,
    transform: "rotate(0,458.5,249.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449,
    y: 259,
    width: 19,
    height: 19,
    transform: "rotate(0,458.5,268.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449,
    y: 335,
    width: 19,
    height: 19,
    transform: "rotate(0,458.5,344.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449,
    y: 354,
    width: 19,
    height: 19,
    transform: "rotate(0,458.5,363.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449,
    y: 411,
    width: 19,
    height: 19,
    transform: "rotate(0,458.5,420.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 468,
    y: 183,
    width: 19,
    height: 19,
    transform: "rotate(0,477.5,192.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 468,
    y: 202,
    width: 19,
    height: 19,
    transform: "rotate(0,477.5,211.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 468,
    y: 259,
    width: 19,
    height: 19,
    transform: "rotate(0,477.5,268.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 468,
    y: 278,
    width: 19,
    height: 19,
    transform: "rotate(0,477.5,287.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 468,
    y: 297,
    width: 19,
    height: 19,
    transform: "rotate(0,477.5,306.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 468,
    y: 316,
    width: 19,
    height: 19,
    transform: "rotate(0,477.5,325.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 468,
    y: 373,
    width: 19,
    height: 19,
    transform: "rotate(0,477.5,382.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 468,
    y: 449,
    width: 19,
    height: 19,
    transform: "rotate(0,477.5,458.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 468,
    y: 468,
    width: 19,
    height: 19,
    transform: "rotate(0,477.5,477.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-square-color-0-0"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M 12 12v 133h 133v -133zM 31 31h 95v 95h -95z",
    transform: "rotate(0,78.5,78.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-dot-color-0-0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 50,
    width: 57,
    height: 57,
    transform: "rotate(0,78.5,78.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-square-color-1-0"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M 354 12v 133h 133v -133zM 373 31h 95v 95h -95z",
    transform: "rotate(90,420.5,78.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-dot-color-1-0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 392,
    y: 50,
    width: 57,
    height: 57,
    transform: "rotate(90,420.5,78.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-square-color-0-1"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M 12 354v 133h 133v -133zM 31 373h 95v 95h -95z",
    transform: "rotate(-90,78.5,420.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-dot-color-0-1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 392,
    width: 57,
    height: 57,
    transform: "rotate(-90,78.5,420.5)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    height: 500,
    width: 500,
    clipPath: "url('#clip-path-background-color')",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    height: 500,
    width: 500,
    clipPath: "url('#clip-path-dot-color')",
    fill: "#000000"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    height: 133,
    width: 133,
    clipPath: "url('#clip-path-corners-square-color-0-0')",
    fill: "#000000"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 50,
    height: 57,
    width: 57,
    clipPath: "url('#clip-path-corners-dot-color-0-0')",
    fill: "#000000"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 354,
    y: 12,
    height: 133,
    width: 133,
    clipPath: "url('#clip-path-corners-square-color-1-0')",
    fill: "#000000"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 392,
    y: 50,
    height: 57,
    width: 57,
    clipPath: "url('#clip-path-corners-dot-color-1-0')",
    fill: "#000000"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 354,
    height: 133,
    width: 133,
    clipPath: "url('#clip-path-corners-square-color-0-1')",
    fill: "#000000"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 392,
    height: 57,
    width: 57,
    clipPath: "url('#clip-path-corners-dot-color-0-1')",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoinTribeQr);
export default __webpack_public_path__ + "static/media/JoinTribeQR.4663f0b5d07494be80c0398131bc9170.svg";
export { ForwardRef as ReactComponent };